import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import TenantProp from '../propTypes/tenantProp';
import Anchor from '../Anchor';
import ConfigsContext from '../../contextProviders/ConfigsContext';

/**
 * Footer component, implemented in React so we can show it and hide it whenever it makes sense
 */
const isAbsoluteUrl = url => /^https?:\/\//i.test(url || '');

export default function Footer({ version, tenant }) {
  const { organization, tenant: tenantFromContext } = useContext(ConfigsContext);
  const effectiveTenant = tenant || tenantFromContext || {};
  const { branding, terms } = effectiveTenant;
  const appName = branding?.appName || '';
  const termsUrl = organization?.termsAndConditions
    ? '/terms-and-conditions'
    : terms?.termsLink;
  const privacyUrl = organization?.privacyPolicy
    ? '/privacy-policy'
    : terms?.privacyLink;
  return (
    <footer className="m-grid__item m-footer ">
      <div className="m-container m-container--responsive m-container--xxl m-container--full-height m-page__container">
        <div className="m-footer__wrapper">
          <div className="m-stack m-stack--flex-tablet-and-mobile m-stack--ver m-stack--desktop">
            <div className="m-stack__item m-stack__item--left m-stack__item--middle m-stack__item--last">
              <span className="m-footer__copyright">
                {`${new Date().getFullYear()} © By `}
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href="https://bravon.io"
                >
                  Bravon
                </a>
                {(termsUrl || privacyUrl) && (
                  <span style={{ whiteSpace: 'pre-wrap' }}>
                    {' - '}
                    {termsUrl && (
                      <Anchor
                        target="_blank"
                        rel="noopener noreferrer"
                        href={termsUrl}
                        redirectToAnotherDomain={isAbsoluteUrl(termsUrl)}
                      >
                        {appName ? `${appName}'s Terms of Use` : 'Terms of Use'}
                      </Anchor>
                    )}
                    {termsUrl && privacyUrl && ' & '}
                    {privacyUrl && (
                      <Anchor
                        target="_blank"
                        rel="noopener noreferrer"
                        href={privacyUrl}
                        redirectToAnotherDomain={isAbsoluteUrl(privacyUrl)}
                      >
                        {appName
                          ? `${appName} Privacy Policy`
                          : 'Privacy Policy'}
                      </Anchor>
                    )}
                  </span>
                )}
              </span>
            </div>
            <div className="m-stack__item m-stack__item--right m-stack__item--middle m-stack__item--first">
              <span className="m-footer__copyright">{version}</span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}

Footer.propTypes = {
  /** App version to display on form footer in development builds */
  version: PropTypes.string.isRequired,
  tenant: PropTypes.shape(TenantProp.propTypes),
};

Footer.defaultProps = {
  tenant: null,
};
